import { SignupAccountRequest } from '@akin-home/accounts';
import { graphqlCall, signupAccount } from '@akin-home/amplify';

export const signupAccountCall = async (params: SignupAccountRequest) => {
  return await graphqlCall(signupAccount, {
    data: JSON.stringify(params),
  });
};
